const VerticalLayout = () => import('@/layouts/VerticalLayout')

const serviceslist = () => import('./views/list')
const serviceTickets = () => import('./views/tickets')
const serviceFlows = () => import('./views/flows')
const serviceActivities = () => import('./views/activities')
const serviceCourses = () => import('./views/courses')
const serviceProducts = () => import('./views/products')
const serviceAccommodations = () => import('./views/accommodations')

// Tabs of the services page, in display order; a tab the admin can't open falls back to the next allowed one.
const fallbackRoutes = ['services', 'serviceFlows', 'serviceActivities', 'serviceCourses', 'serviceProducts', 'serviceAccommodations']

export default [
  {
    path: '/services',
    name: 'services',
    component: VerticalLayout,
    children: [{
      path: '',
      name: 'services',
      meta: { name: 'services', userType: 'admin', permission: ['all_service_tickets', 'all_service_list'] },
      component: serviceslist,
      children: [{
        path: '',
        name: 'services',
        meta: { name: 'services', userType: 'admin', permission: 'all_service_tickets', fallbackRoutes },
        component: serviceTickets
      },
      {
        path: 'flows',
        name: 'serviceFlows',
        meta: { name: 'services', userType: 'admin', permission: 'all_service_list', fallbackRoutes },
        component: serviceFlows
      },
      {
        path: 'activities',
        name: 'serviceActivities',
        meta: { name: 'services', userType: 'admin', permission: 'all_service_list', fallbackRoutes },
        component: serviceActivities
      }, {
        path: 'courses',
        name: 'serviceCourses',
        meta: { name: 'services', userType: 'admin', permission: 'all_service_list', fallbackRoutes },
        component: serviceCourses
      }, {
        path: 'products',
        name: 'serviceProducts',
        meta: { name: 'services', userType: 'admin', permission: 'all_service_list', fallbackRoutes },
        component: serviceProducts
      }, {
        path: 'accommodations',
        name: 'serviceAccommodations',
        meta: { name: 'services', userType: 'admin', permission: 'all_service_list', fallbackRoutes },
        component: serviceAccommodations
      }
      ]
    }
    ]
  }
]
